import "../about.css";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import card from "./card";

function AboutCard() {
  return (
    <Container className="cartContainer">
      {card.map((item, index) => (
        <div key={index} className="cartItem">
          <Row>
            <Col xs={6} md={4}>
              <Image
                src={item.imageUrl}
                roundedCircle
                width={200}
                height={200}
              />
            </Col>
          </Row>
          <div className="cartText">
            <h1>{item.title}</h1>
            <p>{item.description}</p>
            <button
              type="button"
              onClick={() =>
                window.open("https://www.kounouz.travel/", "_blank")
              }
            >
              Click Me
            </button>
          </div>
        </div>
      ))}
    </Container>
  );
}

export default AboutCard;
